import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=01f0b494&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=01f0b494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0b494",
  null
  
)

export default component.exports